var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text",class:{ client: _vm.message.chatUserRole === 'Customer' }},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.message.content)}}),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm._f("localTime")(_vm.message.createAt)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }